import { API_SECRET_KEY, API_MODE } from '../common/Config';

export const encodeRequestData = (data) => {
    const stringToEncodeForToken = `${data.msisdn}|${data.requestType}|${API_SECRET_KEY}`;
    const generatedToken = btoa(stringToEncodeForToken);

    const finalRequestBody = {
        ...data,
        m: API_MODE,
        token: generatedToken,
    };
    return finalRequestBody;
};


export const decodeResponseData = (responseData) => {
    
    try {
        if (typeof responseData === 'object' && responseData !== null) {
          
            return responseData;
        } else if (typeof responseData === 'string') {
           
            try {
                return JSON.parse(responseData);
            } catch (jsonError) {
                console.warn("decodeResponseData: Received string, but it's not valid JSON. Attempting direct return.");
                
                return null; 
            }
        } else {
            console.error("decodeResponseData: Unexpected response data type:", typeof responseData, responseData);
            return null;
        }
    } catch (error) {
        console.error("Error in decodeResponseData:", error);
        return null;
    }
};